import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { ConfigurationService } from '../../common/services/configuration.service';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Subject } from 'rxjs';
import { SearchInput } from '../../common/models/SearchInput';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { HttpcallService } from '../../common/services/httpcall.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionService } from '../../common/services/Session.service';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { constObj } from '../../common/Constants/constants';
import { Location } from '@angular/common';

@Component({
  selector: 'app-left-side-menu',
  templateUrl: './left-side-menu.component.html',
  styleUrls: ['./left-side-menu.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0,0,0)',
        opacity: 1,
      })),
      state('out', style({
        transform: 'translate3d(-10%,0,0)',
        opacity: 0,
        // zIndex : 1
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out')),
    ])
  ]
})
export class LeftSideMenuComponent implements OnInit {
  logo: any;
  logoutURL: any;
  searchInput: SearchInput = new SearchInput();
  GoToFormGroup: FormGroup;

  @ViewChild('autoCompleteInput', { read: MatAutocompleteTrigger })
  autoComplete: MatAutocompleteTrigger;

  @HostListener('document:keydown', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.closeNav();
    }
  }

  @ViewChild("navLevel1") elemLevel1: ElementRef;
  @ViewChild("navLevel2") elemLevel2: ElementRef;
  @ViewChild("navLevel3") elemLevel3: ElementRef;
  @ViewChild("navLevel4") elemLevel4: ElementRef;
  @ViewChild("navLevel5") elemLevel5: ElementRef;
  private searchSub$ = new Subject<string>();
  private searchSuggestionSub$ = new Subject<string>();
  private GotoSub$ = new Subject<string>();
  private _baseUrl: string;
  constructor(
    private http: HttpClient,
    private route: Router,
    public commonDataService: CommonDataService,
    private graphqlService: GraphqlService,
    private _loginservice: LoginService,
    private domSanitizer: DomSanitizer,
    private _configurationservice: ConfigurationService,
    private loginService: LoginService,
    private httpCall: HttpcallService,
    private formBuilder: FormBuilder, private session: SessionService,
    public dialog: MatDialog,
    private location: Location
  ) {
    this._baseUrl = "";
    if (this.route.url.includes("ASCpdfs")) { this.pdfBackup = true; } else {
      this.pdfBackup = false;
      if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
        this.loginService.getSession().subscribe(data => {
          if (data.user != null) {
            this.emailId = data.user.email;
            this.role = data.user.roles;
            this.session.assignUserInfo(data.user);
          }
          else { this.route.navigateByUrl("/Login"); }
        });
      }
      else {
        this.emailId = this.session.userInfo.user.email;
        this.role = this.session.userInfo.user.roles;
      }
    }
  }

  originalIndex: number;
  selectedIndexLevel1: number;
  selectedIndexLevel2: number;
  selectedIndexLevel3: number;
  selectedIndexLevel4: number;
  selectedIndexLevel5: number;
  searchtext;
  showButton;
  enterText;
  text;
  hereExample;
  example1;
  example2;
  searchText: string = "";
  paragraphHeader;
  sectionHeader;
  topicsHeader;
  othersHeader;
  otherSourceHeader: string;
  topResults;
  menuOpen: boolean = false;
  flag: boolean;
  tempData: any;
  flagSearch: boolean = true;
  l2State: string = "out"
  l3State: string = "out"
  l4State: string = "out"
  l5State: string = "out"
  btnState: string = "out";
  crumbData = []
  crumbDataNav = []
  menuIndexNegativeArr = [
    true,
    true,
    true,
    true
  ]
  apiResponse;
  navPanelData;
  navigationLabels = {};
  searchLabel: string = "";
  searchIcon: string = "";
  searchLink: string = "";
  outcome: boolean = false;
  pagepublicationId: { publid: string, pageid: string, pagetitle: string, pageurl: any, pageName: string }[] = [];
  emailId: string = "";
  role: string = "";
  pagepubllist: { sectionarray: object[], sectionname: string, mainsectionname: string }[] = [];
  pdfBackup: boolean = false;

  scrollEvent = (event: any): void => {
    if (this.autoComplete?.panelOpen)
      // this.autoComplete.closePanel();
      this.autoComplete.updatePosition();
  };

  ngOnInit(): void {
    if (this.route.url.includes("ASCpdfs")) {
      this.pdfBackup = true;
      this.loadLogo(); this.outcome = true; }
    else {
      this.pdfBackup = false;
      window.addEventListener('scroll', this.scrollEvent, true);
      this.GoToFormGroup = this.formBuilder.group({
        goToText: [''],
      });
      this.searchSub$.pipe(
        debounceTime(100),
        distinctUntilChanged()
      ).subscribe((filterValue: string) => {
        this.onSearchChange(filterValue);
      });
      this.loadLogo();
      this.searchSuggestionSub$.pipe(
        debounceTime(100),
        distinctUntilChanged()
      ).subscribe((filterValue: string) => {
        this.searchSuggestions(filterValue);
      });
      this.GotoSub$.pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe((filterValue: string) => {
        this.GoToSuggestions(filterValue);
      });
      // this._loginservice.getlogoutURL(window.location.origin),
      let rawLeftNavigation: any = JSON.parse(localStorage.getItem("rawLeftNavigationMenu"));
      if (rawLeftNavigation != undefined) {
        this.getLeftNavigation(rawLeftNavigation);
        let publicationId = rawLeftNavigation[1].itemData[0].itemData[0].itemData[0].itemLink.split('/');
        localStorage.setItem("publicationId", publicationId[0]);
        this.outcome = true;
      }
      else {
        this.graphqlService.getLeftNavigation().subscribe(leftNavigationData => {
          this.getLeftNavigation(leftNavigationData);
          let publicationId1 = leftNavigationData[1].itemData[0].itemData[0].itemData[0].itemLink.split('/');
          localStorage.setItem("publicationId", publicationId1[0]);
          this.outcome = true;
        });
      }
      this.commonDataService.openSearchMenu.subscribe(data => {
        if (data == "open") {
          this.search()
        }
      })

      this.event$
        = this.route.events
          .pipe(
            filter(event => event instanceof NavigationEnd)
          )
          .subscribe(() => {
            this.area = "";
            if (this.route.url.split("/")[1].split("-").length > 2) {
              this.getBreadcrumbForNav(this.route.url.split("/")[1].split("-")[0]);
              this.isSearchClicked = false;
            }
            else if (this.route.url.includes("showallinonepage") || this.route.url.includes("tableOfContent")) {
              this.getBreadcrumbForNav(this.route.url.split("/")[1]);
              this.isSearchClicked = false;
            }
            else if ((!this.route.url.includes("showallinonepage")) && (!this.route.url.includes("tableOfContent"))) {
              let urlParts = this.route.url.split("/");
              if (urlParts.length > 2) {
                this.getBreadcrumbWithRouteUrl(urlParts[1] + "/" + urlParts[2]);
                this.isSearchClicked = false;
              }
              else if (this.route.url.includes("Home")) {
                this.isSearchClicked = false;
                this.area = '';
                this.selectedIndexLevel1 = undefined;
              }
              else if (this.route.url.includes("myaccountdetails") || this.route.url.includes("MyHistory") || this.route.url.includes("myAnnotations") || this.route.url.includes("myBookmarks") || this.route.url.includes("mysubscriptioninformation") || this.route.url.includes("Analytics") || this.route.url.includes("RedisCacheManagement")) {
                this.isSearchClicked = false;
                this.area = "My ASC";
              }
              else if (this.route.url.includes("crossreference") || this.route.url.includes("pendingcontentsystemagreement") || this.route.url.includes("pendingcontentsystem") || this.route.url.includes("help") || this.route.url.includes("taxonomyelementsreferencefile")) {
                this.isSearchClicked = false;
                this.area = "Tools";
              }
              else if (this.route.url.includes("conceptsstatements") || this.route.url.includes("supersededstandards") || this.route.url.includes("aicpa")) {
                this.isSearchClicked = false;
                this.area = "Other Sources";
              }
              else if (this.route.url.includes("MasterGlossary")) {
                this.isSearchClicked = false;
                this.area = "Master Glossary";
              }

              else if (this.route.url.includes("search")) {
                this.isSearchClicked = true;
                this.area = "";
                this.selectedIndexLevel1 = 100;
              }
              else {
                this.isSearchClicked = false;
                this.area = "";
                this.selectedIndexLevel1 = undefined;
              }
            } else {
              this.isSearchClicked = false;
              this.area = "";
              this.selectedIndexLevel1 = undefined;
            }
            if (this.GotoRoutingDone && this.commonDataService.gotoUrl.getValue() == "" && this.GoToFormGroup.controls.goToText.value != "") {
              this.clearSearchGotoText();
              this.GotoRoutingDone = false;
            }
          });
    }
  }
  event$;
  //ngAfterViewChecked() {
  // if (this.GotoRoutingDone && this.commonDataService.gotoUrl.getValue() == "" && this.GoToFormGroup.controls.goToText.value != "") {
  //   this.clearSearchGotoText();
  //   this.GotoRoutingDone = false;
  // }
  //}

  getArea() {
    this.area = "";
    if (this.route.url.split("/")[1].split("-").length > 2) {
      this.getBreadcrumbForNav(this.route.url.split("/")[1].split("-")[0]);
      this.isSearchClicked = false;
    }
    else if (this.route.url.includes("showallinonepage") || this.route.url.includes("tableOfContent")) {
      this.getBreadcrumbForNav(this.route.url.split("/")[1]);
      this.isSearchClicked = false;
    }
    else if ((!this.route.url.includes("showallinonepage")) && (!this.route.url.includes("tableOfContent"))) {
      let urlParts = this.route.url.split("/");
      if (urlParts.length > 2) {
        this.getBreadcrumbWithRouteUrl(urlParts[1] + "/" + urlParts[2]);
        this.isSearchClicked = false;
      }
      else if (this.route.url.includes("Home")) {
        this.isSearchClicked = false;
        this.area = '';
        this.selectedIndexLevel1 = undefined;
      }
      else if (this.route.url.includes("myaccountdetails") || this.route.url.includes("MyHistory") || this.route.url.includes("myAnnotations") || this.route.url.includes("myBookmarks") || this.route.url.includes("mysubscriptioninformation") || this.route.url.includes("Analytics")) {
        this.isSearchClicked = false;
        this.area = "My ASC";
      }
      else if (this.route.url.includes("crossreference") || this.route.url.includes("pendingcontentsystemagreement") || this.route.url.includes("pendingcontentsystem") || this.route.url.includes("help") || this.route.url.includes("taxonomyelementsreferencefile")) {
        this.isSearchClicked = false;
        this.area = "Tools";
      }
      else if (this.route.url.includes("conceptsstatements") || this.route.url.includes("supersededstandards") || this.route.url.includes("aicpa")) {
        this.isSearchClicked = false;
        this.area = "Other Sources";
      }
      else if (this.route.url.includes("MasterGlossary")) {
        this.isSearchClicked = false;
        this.area = "Master Glossary";
      }
      else if (this.route.url.includes("search")) {
        this.isSearchClicked = true; this.area = '';
        this.selectedIndexLevel1 = undefined;
      }
      else {
        this.isSearchClicked = false;
        this.area = "";
        this.selectedIndexLevel1 = undefined;
      }
    }
    else {
      this.isSearchClicked = false;
      this.area = "";
    }
  }

  applyFilter(filterValue: string) {
    this.searchSub$.next(filterValue)
  }

  fetchSuggestion(filterValue: string) {
    this.searchSuggestionSub$.next(filterValue);

  }

  searchSuggestions(filterValue) {
    this.graphqlService.getAutoSuggestionsElasticSearch(filterValue).subscribe(suggestions => {
      if (suggestions) {
        this.autoSuggestion = suggestions?.suggest?.mySuggestion[0]?.options;
        this.autoSuggestedOptionLength = this.autoSuggestion?.length;
      }
    })
  }

  glossaryToolsHeader: string = "";
  GotoRoutingDone: boolean;
  search() {
    this.selectedIndexLevel2 = undefined;
    this.selectedIndexLevel3 = undefined;
    this.selectedIndexLevel4 = undefined;
    this.selectedIndexLevel5 = undefined;
    this.l5State = "out";
    this.l4State = "out";
    this.l3State = "out";
    this.l2State = "in";
    this.btnState = "in";
    this.flag = true;

    this.searchText = "";
    this.searchInput.inputText = "";

    this.graphqlService.getSearchLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.showButton = labels.filter(x => x.key == "search_showResultsText").map(y => y.value);
        this.searchtext = labels.filter(x => x.key == "search_searchAscFor").map(y => y.value);
        this.enterText = labels.filter(x => x.key == "search_EnterText").map(y => y.value);
        this.text = labels.filter(x => x.key == "search_instruction").map(y => y.value);
        this.hereExample = labels.filter(x => x.key == "search_HereExample").map(y => y.value);
        this.example1 = labels.filter(x => x.key == "search_Example1").map(y => y.value);
        this.example2 = labels.filter(x => x.key == "search_Example2").map(y => y.value);
        this.paragraphHeader = labels.filter(x => x.key == "search_paragraphText").map(y => y.value);
        this.sectionHeader = labels.filter(x => x.key == "search_sectionText").map(y => y.value);
        this.topicsHeader = labels.filter(x => x.key == "search_topicText").map(y => y.value);
        this.othersHeader = labels.filter(x => x.key == "search_otherText").map(y => y.value);
        this.topResults = labels.filter(x => x.key == "search_TopResults").map(y => y.value);
        this.otherSourceHeader = labels.filter(x => x.key == "search_otherSourceText").map(y => y.value);
        this.glossaryToolsHeader = labels.filter(x => x.key == "search_glossary_and_tools_Text").map(y => y.value);
      }
    });


  }
  applyGoToFilter(filterValue: string) {
    this.GotoSub$.next(filterValue)
  }
  leftNavSuggestions: any = [];
  GoToSuggestions(GoToValue) {
    this.SearchTextError = "";
    this.leftNavSuggestions = [];
    if (GoToValue.trimEnd() != "") {
      var GotoVal = "";
      if (GoToValue.includes("-")) {
        if (GoToValue.split("-").filter(x => x == "").length > 0) {
          GoToValue.split("-").forEach(element => {
            if (element != "") {
              GotoVal += "-" + element;
            }
          });
          GoToValue = GotoVal.split("-").slice(1, GotoVal.split("-").length).join("-");
        }
      }
      if (GoToValue.trimStart().trimEnd().length >= 3) {
        this.getBreadcrumbWithNavPath(GoToValue.trimStart().trimEnd());
      }
      else {
        this.getBreadcrumbForTopic(GoToValue.trimStart().trimEnd());
      }
      this.leftNavSuggestions = this.BreadcrumbData;
    }
    // else if(GoToValue.trimEnd()==""){
    //   this.GoToFormGroup.controls.goToText.reset();
    // }
  }
  suggestedGoToValue(goToValue) {
    this.GoToFormGroup.controls.goToText.setValue(goToValue);
    //  this.GoToPage();
  }
  GoToPage() {
    let url; let paraNum;
    let goToText = this.GoToFormGroup.controls.goToText.value;
    this.closeNav();
    if (this.isValidText(this.GoToFormGroup.controls.goToText.value)) {
      var ids = goToText.split("-");
      paraNum = goToText;
      if (goToText.includes("(")) {
        paraNum = goToText.split("(")[0];
      }
      if (goToText.includes("[")) {
        paraNum = goToText.split("[")[0];
      }
      if (goToText.includes("to")) {
        paraNum = goToText.split(" to")[0];
      }
      if (goToText.includes("through")) {
        paraNum = goToText.split(" through")[0];
      }
      goToText = ids.length == 4 ? goToText.split("-").slice(0, 3).join('-') : goToText;
      if (goToText.trimEnd() != "") {
        this.getBreadcrumbWithNavPath(goToText.trimStart().trimEnd());
        if (this.navPathFound) {
          if (ids.length == 1) {
            url = goToText + "/tableOfContent";
            //this.route.routeReuseStrategy.shouldReuseRoute = () => false;
            this.commonDataService.gotoUrl.next(url);
            this.GotoRoutingDone = true;
            this.commonDataService.glossaryTermFromContentPageBackButton.next("");
            //this.route.navigateByUrl(url);
            this.popupRedirect(url);
          }
          else if (ids.length <= 4 && ids.length > 1) {
            if (ids.length == 2 && (this.navPathUrl == null || this.navPathUrl == "")) {
              url = goToText + "/tableOfContent";
              //this.route.routeReuseStrategy.shouldReuseRoute = () => false;
              this.commonDataService.gotoUrl.next(url);
              this.GotoRoutingDone = true;
              this.commonDataService.glossaryTermFromContentPageBackButton.next("");
              //this.route.navigateByUrl(url);
              this.popupRedirect(url);
            }
            else if (this.navPathUrl != null || this.navPathUrl != "") {
              url = this.navPathUrl;
              if (ids.length == 4) {
                url = url + "/" + paraNum.toUpperCase().trimEnd().trimStart();
              }
              //this.route.routeReuseStrategy.shouldReuseRoute = () => false;
              this.commonDataService.gotoUrl.next(url);
              this.GotoRoutingDone = true;
              this.commonDataService.glossaryTermFromContentPageBackButton.next("");
              //this.route.navigateByUrl(url);
              this.popupRedirect(url);
            }
          }
        }
        else {
          this.GotoRoutingDone = false;
          this.SearchTextError = "No records found.";
        }
      }

    }
  }
  clearSearchGotoText() {
    this.commonDataService.glossaryTermFromContentPageBackButton.next("");
    this.GoToFormGroup.controls.goToText.reset();
    this.SearchTextError = "";
  }
  SearchTextError: string = "";
  isValidText(goToText) {
    var ids = goToText.split("-");
    if (goToText.trimEnd() == "") {
      this.GoToFormGroup.controls.goToText.reset();
      return true;
    }
    else if (ids.length > 4 || isNaN(ids[0]) || (ids.length > 1 && isNaN(ids[1])) || ids.filter(x => x == "").length > 0) {
      this.SearchTextError = "No records found.";
      return false;
    }
    else {
      this.SearchTextError = ""
      return true;
    }
  }

  searchComponentRedirection() {
    this.autoSuggestion = [];
    if (this.searchText.length > 0) {
      this.searchInput.inputText = this.searchText;
      localStorage.setItem("ElasticSearchTerm", this.searchText);
      var searchTerm = { "Id": "-1", "SearchKeyword": this.searchText, "Application": "", "CreateDate": "", "UpdateDate": "", "UpdateUserId": "", "IsActive": true }
      //Added condition to prevent addSearchTerm api call for External/Basic view in Leftnav Search - MS-772
      if (this.session.userInfo != null && this.session.userInfo.user != null && this.session.userInfo.user.roles == "Professional") {
        this.httpCall.addSearchTerm(searchTerm).subscribe(data => console.log(data));
      }
      this.clearSearchGotoText();
      this.route.navigateByUrl("/search" + "?query=" + this.searchInput.inputText);
      //this.popupRedirect("/search");
      this.commonDataService.searchPageRefresh.next(this.searchText);
      this.l5State = "out";
      this.l4State = "out";
      this.l3State = "out";
      this.l2State = "out";
      this.btnState = "out";
    }
  }

  isSearchClicked: boolean = false;
  top5ParaRecords;
  top5TopicRecords;
  top5OtherSourceRecords: any = [];
  autoSuggestion;
  autoSuggestedOptionLength: number = 0;
  numberOfResult: number = 0;
  glossaryResult;
  annotationResult;
  bookmarkResult;
  category: number = 0;
  top5PdfRecords: any = [];
  onSearchChange(searchValue: string): void {
    this.category = 0;
    this.autoSuggestion = [];
    this.top5OtherSourceRecords = [];
    this.top5ParaRecords = [];
    this.top5TopicRecords = [];
    this.top5PdfRecords = [];
    this.glossaryResult = [];
    this.annotationResult = [];
    this.bookmarkResult = [];
    if (this.role != "Professional" || searchValue == null || searchValue == "") {
      forkJoin(
        this.graphqlService.getAutoSuggestionsElasticSearch(searchValue),
        this.graphqlService.getTop5ParagraphElasticSearch(searchValue),
        this.graphqlService.getTop5TopicsElasticSearch(searchValue),
        this.graphqlService.getTop5OtherSourceElasticSearch(searchValue),
        this.graphqlService.GetMasterGlossarySearchResult(searchValue, 0, "leftnav"))
        .subscribe(([suggestions, top5Paras, top5Topics, top5otherSource, glossaryContent]) => {
          this.autoSuggestion = suggestions?.suggest?.mySuggestion[0]?.options;
          this.autoSuggestedOptionLength = this.autoSuggestion?.length;
          this.top5ParaRecords = top5Paras?.hits?.hitsList;
          this.numberOfResult = top5Paras?.hits?.total?.value;
          this.top5TopicRecords = top5Topics?.hits?.hitsList;
          this.top5OtherSourceRecords = top5otherSource?.hits?.hitsList;
          // if (this.top5OtherSourceRecords.length == 0 || this.top5OtherSourceRecords.length < 5){
          //   this.getPdfSearchResults(searchValue, 5-this.top5OtherSourceRecords.length);
          // }
          // else{
          //   this.top5PdfRecords=[];
          // }
          //this.glossaryResult = glossaryContent.hits.hitsList;
          let counter = 0;
          this.glossaryResult = [];
          if (counter < 5) {
            glossaryContent.hits.hitsList.forEach(element => {
              if (element && counter < 5) {
                if (this.glossaryResult.filter(x => x.source.title == element.source.title).length == 0) {
                  counter = counter + 1;
                  this.glossaryResult.push(element);
                }
              }
            });
          }
          if (counter > 0) { this.category++ }
          if (this.top5ParaRecords?.length > 0) { this.category++ }
          if (this.top5OtherSourceRecords?.length > 0 || this.top5PdfRecords.length > 0) { this.category++ }
          if (this.top5TopicRecords?.length > 0) { this.category++ }
        });
    } else {
      forkJoin(
        this.graphqlService.getAutoSuggestionsElasticSearch(searchValue),
        this.graphqlService.getTop5ParagraphElasticSearch(searchValue),
        this.graphqlService.getTop5TopicsElasticSearch(searchValue),
        this.graphqlService.getTop5OtherSourceElasticSearch(searchValue),
        this.httpCall.getElasticAnnotation(searchValue, "5", ""),
        this.httpCall.getElasticBookmark(searchValue, "5", ""),
        this.graphqlService.GetMasterGlossarySearchResult(searchValue, 0, "leftnav"))
        .subscribe(([suggestions, top5Paras, top5Topics, top5otherSource, annotations, bookmark, glossaryContent]) => {
          this.autoSuggestion = suggestions?.suggest?.mySuggestion[0]?.options;
          this.autoSuggestedOptionLength = this.autoSuggestion?.length;
          this.top5ParaRecords = top5Paras?.hits?.hitsList;
          this.numberOfResult = top5Paras?.hits?.total?.value;
          this.top5TopicRecords = top5Topics?.hits?.hitsList;
          this.top5OtherSourceRecords = top5otherSource?.hits?.hitsList;
          // if (this.top5OtherSourceRecords.length == 0 || this.top5OtherSourceRecords.length < 5){
          //   this.getPdfSearchResults(searchValue, 5-this.top5OtherSourceRecords.length);
          // }
          // else{
          //   this.top5PdfRecords=[];
          // }
          // this.glossaryResult = glossaryContent.hits.hitsList;
          this.annotationResult = annotations;
          this.bookmarkResult = bookmark;

          let counter = 0;
          let bookmarks = [];
          this.glossaryResult = [];
          if (this.annotationResult.length < 5) {
            counter = this.annotationResult.length;
            if (counter < 5) {
              this.bookmarkResult.forEach(bookmarkRes => {
                if (bookmarkRes && counter < 5) {
                  counter = counter + 1;
                  bookmarks.push(bookmarkRes);
                }
              });
            }
            this.bookmarkResult = bookmarks;
          }
          else {
            counter = this.annotationResult.length;
            if (counter == 5) {
              this.bookmarkResult = bookmarks;
            }
          }
          if (counter < 5) {
            glossaryContent.hits.hitsList.forEach(element => {
              if (element && counter < 5) {

                if (this.glossaryResult.filter(x => x.source.title == element.source.title).length == 0) {
                  counter = counter + 1;
                  this.glossaryResult.push(element);
                }

              }
            });
          }
          if (counter > 0) { this.category++ }
          if (this.top5ParaRecords?.length > 0) { this.category++ }
          if (this.top5OtherSourceRecords?.length > 0 || this.top5PdfRecords.length > 0) { this.category++ }
          if (this.top5TopicRecords?.length > 0) { this.category++ }
        });
    }

  }

  getPdfSearchResults(searchValue, dataCount) {
    this.graphqlService.getTop5PdfElasticSearch(searchValue, dataCount).subscribe(pdfRes => {
      this.top5PdfRecords = pdfRes?.hits?.hitsList;
    })
  }

  suggestedValue(value) {
    this.onSearchChange(value);
  }


  redirectToUrl(source) {
    this.clearSearchGotoText();
    if ((source.url.includes('.')) && (source.url.split('.').pop() === 'pdf')) {
      this.graphqlService.getS3BucketImagePath().subscribe(data => {
        let url = data + "/" + source.url;
        window.open(url);
      });
    }
    else {
      this.clearSearchGotoText();
      this.route.navigateByUrl(source.url);
      this.closeNav();
    }
  }
  getMiniLeftNav(leftNavigation) {
    let miniLeftNav: any[] = [];
    for (let i = 0; i < leftNavigation.length; i++) {
      let miniLeftNavLevel1: any = {};
      miniLeftNavLevel1.item = leftNavigation[i].item;
      miniLeftNavLevel1.itemLink = leftNavigation[i].itemLink;
      miniLeftNavLevel1.navPath = leftNavigation[i].navPath;
      miniLeftNavLevel1.archiveListGuids = leftNavigation[i].archiveListGuids;
      miniLeftNavLevel1.afterShowAllInOnePageRequired = leftNavigation[i].afterShowAllInOnePageRequired;
      if (leftNavigation[i].itemData != null) {
        let leftNavLevel2 = [];
        for (let j = 0; j < leftNavigation[i].itemData.length; j++) {
          let miniLeftNavLevel2: any = {};
          miniLeftNavLevel2.item = leftNavigation[i].itemData[j].item;
          miniLeftNavLevel2.itemLink = leftNavigation[i].itemData[j].itemLink;
          miniLeftNavLevel2.navPath = leftNavigation[i].itemData[j].navPath;
          miniLeftNavLevel2.archiveListGuids = leftNavigation[i].itemData[j].archiveListGuids;
          miniLeftNavLevel2.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].afterShowAllInOnePageRequired;
          if (leftNavigation[i].itemData[j].itemData != null) {
            let leftNavLevel3 = [];
            for (let k = 0; k < leftNavigation[i].itemData[j].itemData.length; k++) {
              let miniLeftNavLevel3: any = {};
              miniLeftNavLevel3.item = leftNavigation[i].itemData[j].itemData[k].item;
              miniLeftNavLevel3.itemLink = leftNavigation[i].itemData[j].itemData[k].itemLink;
              miniLeftNavLevel3.navPath = leftNavigation[i].itemData[j].itemData[k].navPath;
              miniLeftNavLevel3.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].archiveListGuids;
              miniLeftNavLevel3.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].afterShowAllInOnePageRequired;
              if (leftNavigation[i].itemData[j].itemData[k].itemData != null) {
                let leftNavLevel4 = [];
                for (let m = 0; m < leftNavigation[i].itemData[j].itemData[k].itemData.length; m++) {
                  let miniLeftNavLevel4: any = {};
                  miniLeftNavLevel4.item = leftNavigation[i].itemData[j].itemData[k].itemData[m].item;
                  miniLeftNavLevel4.itemLink = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemLink;
                  miniLeftNavLevel4.navPath = leftNavigation[i].itemData[j].itemData[k].itemData[m].navPath;
                  miniLeftNavLevel4.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].itemData[m].archiveListGuids;
                  miniLeftNavLevel4.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].itemData[m].afterShowAllInOnePageRequired;
                  if (leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData != null) {
                    let leftNavLevel5 = [];
                    for (let n = 0; n < leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData.length; n++) {
                      let miniLeftNavLevel5: any = {};
                      miniLeftNavLevel5.item = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].item;
                      miniLeftNavLevel5.itemLink = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].itemLink;
                      miniLeftNavLevel5.navPath = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].navPath;
                      miniLeftNavLevel5.archiveListGuids = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].archiveListGuids;
                      miniLeftNavLevel5.afterShowAllInOnePageRequired = leftNavigation[i].itemData[j].itemData[k].itemData[m].itemData[n].afterShowAllInOnePageRequired;
                      leftNavLevel5.push(miniLeftNavLevel5);
                    }
                    miniLeftNavLevel4.itemData = leftNavLevel5;
                  }
                  leftNavLevel4.push(miniLeftNavLevel4);
                }
                miniLeftNavLevel3.itemData = leftNavLevel4;
              }
              leftNavLevel3.push(miniLeftNavLevel3);
            }
            miniLeftNavLevel2.itemData = leftNavLevel3;
          }
          leftNavLevel2.push(miniLeftNavLevel2);
        }
        miniLeftNavLevel1.itemData = leftNavLevel2;
      }
      miniLeftNav.push(miniLeftNavLevel1);
    }
    localStorage.setItem("leftNavigationMenu", JSON.stringify(miniLeftNav));
  }
  openSitesPdf(PdfUrl) {
    if ((PdfUrl.includes('.')) && (PdfUrl.split('.').pop() === 'pdf')) {
      let url = '/layoutComponents/getPdf?isSitesBucket=' + true + '&fileName=' + PdfUrl;//show pdf
      window.open(url);
    }
  }

  showAllInOneRequiredOn3rdLevel: boolean = true;
  getLeftNavigation(data) {
    this.tempData = data;
    this.searchLabel = this.tempData[0].item;
    this.searchIcon = this.tempData[0].logoSrc;
    this.searchLink = this.tempData[0].itemLink;
    this.tempData = this.tempData.filter(x => x.item != this.searchLabel);
    this.tempData[this.tempData.length - 1].logoSrc = this.domSanitizer.bypassSecurityTrustUrl(this.tempData[this.tempData.length - 1].logoSrc);
    this.tempData[this.tempData.length - 2].logoSrc = this.domSanitizer.bypassSecurityTrustUrl(this.tempData[this.tempData.length - 2].logoSrc);
    this.tempData[this.tempData.length - 2].itemData.filter(x => x.item == "My Bookmarks")[0].logoSrc = this.domSanitizer.bypassSecurityTrustUrl(this.tempData[this.tempData.length - 2].itemData.filter(x => x.item == "My Bookmarks")[0].logoSrc);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this._loginservice.getSession().subscribe(sessiondata => {
        this.applyFilterOnNavigation(sessiondata);
      },
        error => {
          console.log('Left-nav', error)
          this.route.navigateByUrl("/Login")
        });
    }
    else {
      this.applyFilterOnNavigation(this.session.userInfo);
    }
  }

  applyFilterOnNavigation(sessiondata) {
    //this.commonDataService.userSession.next(sessiondata.user)
    if (sessiondata.user.roles == "Basic") {
      this.tempData = this.tempData.filter(x => x.item != "My ASC");
      //this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "My Account Details" && x.item != "My History" && x.item != "My Annotations" && x.item != "My Subscription Information" && x.item != "Current Activity" && x.item != "My Bookmarks");
      //this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "Pending Content System");
      //this.tempData[this.tempData.length - 3].itemData = this.tempData[this.tempData.length - 3].itemData.filter(x => x.item != "Accounting Standards Updates" && x.item != "Other Exposure Documents" && x.item != "Proposed Accounting Standards Updates" && x.item != "Pre-Codification Standards" && x.item != "Concept Statements" && x.item != "Implementation Q&A");
    }
    //else if (sessiondata.user.roles == "Academic") {
    //  this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "My Annotations" && x.item != "My Subscription Information" && x.item != "My Account Details" && x.item != "Current Activity" && x.item != "Analytics" && x.item != "My History" && x.item != "My Bookmarks");
    //}
    else {
      let isAdmin = sessiondata.user.isAdmin;
      if (!isAdmin) {
        this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "Current Activity");
        this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "Access Management");
        this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "XBRL Elements");
        this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "Redis Cache Management");
        //if (!sessiondata.user.isUserBypassed) { this.tempData[this.tempData.length - 2].itemData = this.tempData[this.tempData.length - 2].itemData.filter(x => x.item != "Analytics"); }
      }
    }
    localStorage.removeItem("rawLeftNavigationMenu");
    //localStorage.setItem("leftNavigationMenu", JSON.stringify(this.tempData));
    this.getMiniLeftNav(this.tempData);
    this.getArea();
  }


  loadLogo() {
    this.graphqlService.getS3BucketImageASCLogo().subscribe(data => {
      this.logo = this.domSanitizer.bypassSecurityTrustUrl(data);
    });
  }

  //getLogoutURL(data) {
  //  this.logoutURL = data.logoutRedirectURL;
  //  return this.logoutURL;
  //}

  loginPageredirect() {
    if (!this.route.url.includes("ASCpdfs")) {
      this.popupRedirect("/Home");
      this.area = "";
      this.clearSearchGotoText();
      //this.route.navigateByUrl("/Home");
      this.closeNav();
      this.selectedIndexLevel1 = 100;
    }
  }
  urlPath: string = "";
  showSecContent: boolean = true;
  navClicked(obj, index) {
    this.flag = false;
    switch (index) {
      case 1: {
        this.l3State = "out";
        this.l4State = "out";
        this.l5State = "out";
        this.selectedIndexLevel2 = undefined;
        this.selectedIndexLevel3 = undefined;
        this.selectedIndexLevel4 = undefined;
        this.selectedIndexLevel5 = undefined;
        this.crumbDataNav = [
          this.tempData[this.selectedIndexLevel1].item
        ]
        if (this.tempData[this.selectedIndexLevel1].itemData.length === 0) {
          this.l2State = "out";
          this.btnState = "out";
          //let keys = [];
          //for (let obj of this.tempData) {
          //  keys.push({
          //    item: obj.item,
          //    itemLink: obj.itemLink
          //  });
          //}
          //aaa scenario
          if (this.tempData[this.selectedIndexLevel1].item == "My ASC") {

            this.commonDataService.isConfirmationPopUpOpen.next(false);
            this.commonDataService.aaaUserMessage.next(true);
            //const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            //  disableClose: true,
            //  width: '600px',
            //  data: constObj.aaaFeaturemessage
            //});
           return;
          }
          if (this.tempData[this.selectedIndexLevel1].itemLink == "/logout") {
            //this._loginservice.getlogoutURL(window.location.origin).subscribe(data => {
            this.session.assignUserInfo(null);
            this.commonDataService.globalLabels.unsubscribe();
              //this._loginservice.deleteSession().subscribe();
              //window.location.href = this.getLogoutURL(data);
              localStorage.removeItem("isPendingContentPage");
              localStorage.removeItem("PCSIntegratedData");
            //})

            localStorage.removeItem("DefaultSecView");
            localStorage.removeItem("ElasticSearchTerm");
            this.location.replaceState('', ''); // Replace the current entry with a new one
            this.loginService.deleteSession().subscribe(data => {
              if (this.role == "Basic") {
                //window.location.href = "Login";
                this.popupRedirect("Login",1);
              }
              else {
               //window.location.href = "/Login/proViewLogin";
                this.popupRedirect("/Login/proViewLogin",1);
              }
            })
          }
          this.urlPath = this.tempData[this.selectedIndexLevel1].itemLink;
          this.clearSearchGotoText();
          //this.route.navigateByUrl(this.urlPath);
          if (this.urlPath!= '/logout') {this.popupRedirect(this.urlPath);}
          this.isSearchClicked = false;
          this.originalIndex = this.selectedIndexLevel1;
          this.closeNav();
        } else {
          this.l2State = "in";
          this.btnState = "in";
          setTimeout(() => {
            let nextLevelFirstNode = new ElementRef(this.elemLevel2.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
            nextLevelFirstNode.nativeElement.focus();
          }, 400);
        }
        break;
      }
      case 2: {
        this.l4State = "out";
        this.l5State = "out";
        this.selectedIndexLevel3 = undefined;
        this.selectedIndexLevel4 = undefined;
        this.selectedIndexLevel5 = undefined;
        this.crumbData = [
          this.tempData[this.selectedIndexLevel1].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item,
        ]
        if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData.length === 0 && this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemLink != null) {
          this.l3State = "out";
          this.crumbDataNav = this.crumbData;
          //let keys = [];
          //for (let obj of this.tempData[this.selectedIndexLevel1].itemData) {
          //  keys.push({
          //    item: obj.item,
          //    itemLink: obj.itemLink
          //  });
          //}
          this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemLink;
          //const obj = {
          //  crumbData: this.crumbData,
          //  menuData: keys
          //}
          this.clearSearchGotoText();
          //this.route.navigateByUrl(this.urlPath);
          this.popupRedirect(this.urlPath);
          this.isSearchClicked = false;
          if (this.crumbData[1] == "My Annotations" || this.crumbData[1] == "Pending Content System" || this.crumbData[1] == "My Account Details" || this.crumbData[1] == "My Subscription Information" || this.crumbData[1] == "My History" || this.crumbData[1] == "Component Statements") {
            this.commonDataService.EditFromContentPage.next(false);
          }

          this.originalIndex = this.selectedIndexLevel1;
          this.closeNav();

        } else if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData.length > 0) {
          this.l3State = "in";
          this.crumbDataNav = this.crumbData;
          if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].isShowAllInOnePageNotRequired) {
            this.showAllInOneRequiredOn3rdLevel = false;
          } else {
            this.showAllInOneRequiredOn3rdLevel = true;
          }
          setTimeout(() => {
            //let nextLevelFirstNode = new ElementRef(this.elemLevel3.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
            //nextLevelFirstNode.nativeElement.focus();
          }, 400);
        }
        break;
      }
      case 3: {
        this.l5State = "out";
        this.selectedIndexLevel4 = undefined;
        this.selectedIndexLevel5 = undefined;
        this.crumbData = [
          this.tempData[this.selectedIndexLevel1].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item
        ]

        //const myClonedArray = Object.assign([], this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData);
        let itemDataExists = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData;
        if (itemDataExists) {
          if (localStorage.getItem("DefaultSecView") == "true") {
            this.showSecContent = true;
            // this.graphqlService.checkSecMenu().subscribe(leftNavData => {
            //   this.getLeftNavigation(leftNavData);
            // })
          }
          else {
            // this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData = myClonedArray.filter(function (ele) {
            //   return ele.isSecContent == null;
            // });
            this.showSecContent = false;
          }
        }
        if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData.length === 0 && this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemLink != null) {

          this.crumbDataNav = this.crumbData;
          this.l4State = "out";
          //let keys = [];
          //for (let obj of this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData) {
          //  keys.push({
          //    item: obj.item,
          //    itemLink: obj.itemLink
          //  });
          //}
          this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemLink;
          //const obj = {
          //  crumbData: this.crumbData,
          //  menuData: keys
          //}
          this.clearSearchGotoText();
          //this.route.navigateByUrl(this.urlPath);
          this.popupRedirect(this.urlPath);
          this.isSearchClicked = false;
          this.originalIndex = this.selectedIndexLevel1;
          this.closeNav()
        } else if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData.length > 0) {
          this.crumbDataNav = this.crumbData;
          this.l4State = "in";
          setTimeout(() => {
            //let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[1].childNodes[0].childNodes[0]);
            //nextLevelFirstNode.nativeElement.focus();
          }, 400);
        }
        break;
      }
      case 4: {
        this.selectedIndexLevel5 = undefined;
        this.crumbData = [
          this.tempData[this.selectedIndexLevel1].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].item,
        ]

        const myClonedArray = Object.assign([], this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData);
        let itemDataExistsBool = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData;
        if (itemDataExistsBool) {
          if (localStorage.getItem("DefaultSecView") == "true") {
            this.showSecContent = true;
            // this.graphqlService.checkSecMenu().subscribe(leftNavData => {
            //   this.getLeftNavigation(leftNavData);
            // })
          }
          else {
            if (myClonedArray.length > 0) {
              // this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData = myClonedArray.filter(function (ele) {
              //   return ele.isSecContent == null;
              // });
            }
            this.showSecContent = false;
          }
        }

        if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData == null && this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemLink != null) {
          this.l5State = "out";
          this.crumbDataNav = this.crumbData;
          //let keys = [];
          //for (let obj of this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData) {
          //  keys.push({
          //    item: obj.item,
          //    itemLink: obj.itemLink
          //  });
          //}
          this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemLink;
          this.clearSearchGotoText();
          //this.route.navigateByUrl(this.urlPath);
          this.popupRedirect(this.urlPath);
          this.isSearchClicked = false;
          this.originalIndex = this.selectedIndexLevel1;
          this.closeNav();
        } else if (this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData?.length > 0) {
          this.l5State = "in";
          this.crumbDataNav = this.crumbData;
          setTimeout(() => {
            //let nextLevelFirstNode = new ElementRef(this.elemLevel5.nativeElement.childNodes[0].childNodes[1].childNodes[0].childNodes[0]);
            //nextLevelFirstNode.nativeElement.focus();
          }, 400);
        }
        break;
      }
      case 5: {
        this.crumbData = [
          this.tempData[this.selectedIndexLevel1].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].item,
          this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData[this.selectedIndexLevel5].item,
        ]
        this.crumbDataNav = this.crumbData;

        //let keys = [];
        //for (let obj of this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData) {
        //  keys.push({
        //    item: obj.item,
        //    itemLink: obj.itemLink
        //  });
        //}
        this.urlPath = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].itemData[this.selectedIndexLevel4].itemData[this.selectedIndexLevel5].itemLink;
        this.clearSearchGotoText();
        //this.route.navigateByUrl(this.urlPath);
        this.popupRedirect(this.urlPath);
        this.isSearchClicked = false;
        this.originalIndex = this.selectedIndexLevel1;
        this.closeNav();
        break;
      }
    }
  }
  mainsection: string = "";

  showAllInOnePageIncludeSharedSubtopics(obj) {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    if (obj.navPath.split("-").length == 2) {
      if (Number(obj?.navPath?.split("-")[1]) > Number(obj?.navPath?.split("-")[0])) {
        this.mainsection = obj.item;
        obj = this.getBreadcrumbObjWithNavPath(obj.navPath.split("-")[1] + "-" + obj.navPath.split("-")[0]);
      }
      else {
        this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item;
        if (this.mainsection.split(" ")[0].includes("X")) {
          this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item;
        }
      }
    }
    else {
      this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item;
      if (this.mainsection.split(" ")[0].includes("X")) {
        this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item;
      }
    }
    this.getpagepublidsIncludeSharedSubtopics(obj);
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
    this.clearSearchGotoText();
    if (this.mainsection?.split(" ")[0] != obj?.item?.split(" ")[0]) {
      let url = this.mainsection?.split(" ")[0] + '/' + obj?.item?.split(" ")[0] + '/showallinonepageplus';
      //this.route.routeReuseStrategy.shouldReuseRoute = () => false;
      this.route.navigateByUrl(url);
    } else {
      let url = this.mainsection?.split(" ")[0] + '/showallinonepageplus';
      //this.route.routeReuseStrategy.shouldReuseRoute = () => false;
      this.route.navigateByUrl(url);
    }
    this.closeNav();
  }

  getpagepublidsIncludeSharedSubtopics(obj) {
    if (obj.itemData != null) {
      for (let items of obj.itemData) {
        this.getpagepublidsIncludeSharedSubtopics(items);
        //if (items.afterShowAllInOnePageRequired) {
        //  break;
        //}
      }
    }
    if (obj.itemLink != null) {
      if (obj.itemLink.length > 0) {
        let PublpageId = obj.itemLink.split('/').map(d => d);
        let navPath = obj.navPath;
        let navPathSplited = navPath.split("-")
        if (navPathSplited[0].includes("X")) {
          navPathSplited = navPathSplited.slice(1, navPathSplited.length);
        }
        let pageTitle = navPathSplited.join("-");
        if (!navPathSplited[navPathSplited.length - 1].includes("75")) {
          this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageName: obj.item });
        }
      }
    }
    else {
      if (this.pagepublicationId.length > 0) {

        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }

  showAllInOnePage(obj) {
    this.pagepublicationId = [];
    this.pagepubllist = [];
    if (obj.navPath.split("-").length == 2) {
      if (Number(obj?.navPath?.split("-")[1]) > Number(obj?.navPath?.split("-")[0])) {
        this.mainsection = obj.item;
        obj = this.getBreadcrumbObjWithNavPath(obj.navPath.split("-")[1] + "-" + obj.navPath.split("-")[0]);
      }
      else {
        this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item;
        if (this.mainsection.split(" ")[0].includes("X")) {
          this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item;
        }
      }
    }
    else {
      this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].item;
      if (this.mainsection.split(" ")[0].includes("X")) {
        this.mainsection = this.tempData[this.selectedIndexLevel1].itemData[this.selectedIndexLevel2].itemData[this.selectedIndexLevel3].item;
      }
    }
    this.getpagepublids(obj);
    localStorage.setItem("publpageId", JSON.stringify(this.pagepubllist));
    this.clearSearchGotoText();
    if (this.mainsection?.split(" ")[0] != obj?.item?.split(" ")[0]) {
      let url = this.mainsection?.split(" ")[0] + '/' + obj?.item?.split(" ")[0] + '/showallinonepage';
      //this.route.routeReuseStrategy.shouldReuseRoute = () => false;
      // this.route.navigateByUrl(url);
      this.popupRedirect(url); 
    } else {
      let url = this.mainsection?.split(" ")[0] + '/showallinonepage';
      //this.route.routeReuseStrategy.shouldReuseRoute = () => false;
      // this.route.navigateByUrl(url);
      this.popupRedirect(url); 
    }
    this.closeNav();

  }
  /* Start -- Print queue functionality request MS-415*/
  popupRedirect(url, x?) {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    if (printQueueCount > 0) {
      localStorage.setItem("isConfirmPopup", 'true');
      this.commonDataService.isConfirmationPopUpOpen.next(true);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '600px',
        data: constObj.annotationAlertPrintQueue
      });
      dialogRef.afterClosed().subscribe((result: boolean) => {
        localStorage.removeItem("isConfirmPopup");
        if (result == true) {
          this.commonDataService.resetPrintQueue.next(true);
          this.commonDataService.printCount.next("toggleOff");
          this.commonDataService.printToggleOff.next("printToggleOff");
          if (x == 1) {
            window.location.href = url;
          }
          else {
            if (x == 2) {
              this.search()
            } else {
            this.route.navigateByUrl(url);
            }
          }
        }
      });
      return;
          
    } else {
      if (x==1) {
        window.location.href = url;
      } else {
        if (x == 2) {
          this.search()
        } else {
          this.route.navigateByUrl(url);
        }
      }
    }

  }
  /* End -- Print queue functionality request MS-415*/
  getpagepublids(obj) {
    if (obj.itemData != null) {
      for (let items of obj.itemData) {
        this.getpagepublids(items);
        if (items.afterShowAllInOnePageRequired) {
          break;
        }
      }
    }
    if (obj.itemLink != null) {
      if (obj.itemLink.length > 0) {
        let PublpageId = obj.itemLink.split('/').map(d => d);
        let navPath = obj.navPath;
        let navPathSplited = navPath.split("-")
        if (navPathSplited[0].includes("X")) {
          navPathSplited = navPathSplited.slice(1, navPathSplited.length);
        }
        let pageTitle = navPathSplited.join("-");
        if (!navPathSplited[navPathSplited.length - 1].includes("75")) {
          this.pagepublicationId.push({ publid: PublpageId[0], pageid: PublpageId[1], pagetitle: pageTitle, pageurl: obj.itemLink, pageName: obj.item });
        }
      }
    }
    else {
      if (this.pagepublicationId.length > 0) {

        this.pagepubllist.push({ sectionarray: this.pagepublicationId, sectionname: obj.item, mainsectionname: this.mainsection });
        this.pagepublicationId = [];
      }
    }
  }

  highlight: number = undefined;
  closeNav() {
    this.l2State = "out";
    this.l3State = "out";
    this.l4State = "out";
    this.l5State = "out";
    this.btnState = "out";
    this.selectedIndexLevel2 = undefined;
    this.selectedIndexLevel3 = undefined;
    this.selectedIndexLevel4 = undefined;
    this.selectedIndexLevel5 = undefined;
    this.highlight = undefined;
    this.menuOpen = false;
    this.selectedIndexLevel1 = this.originalIndex;
    this.searchText = "";
    this.searchInput.inputText = "";
    if (!this.route.url.includes("search")) {
      this.isSearchClicked = false;
    }
  }

  animationDone(stateAnimation1, index) {
    if (stateAnimation1 === "out") {
      this.menuIndexNegativeArr[index] = true;
    }
  }

  animationStart(stateAnimation2, index) {
    if (stateAnimation2 === "in") {
      this.menuIndexNegativeArr[index] = false;
    }
  }

  nextTab(event) {
    if (event.srcElement.nextSibling) {
      let next = new ElementRef(event.srcElement.nextSibling);
      next.nativeElement.focus();
    }
  }

  previousTab(event) {
    if (event.srcElement.previousSibling) {
      let previous = new ElementRef(event.srcElement.previousSibling);
      previous.nativeElement.focus();
    }
  }

  nextLevel(index) {
    switch (index) {
      case 1: {
        if (this.l2State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel2.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
      case 2: {
        if (this.l3State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel3.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
      case 3: {
        if (this.l4State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
      case 4: {
        if (this.l5State === "in") {
          let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
          nextLevelFirstNode.nativeElement.focus();
        }
        break;
      }
    }
  }

  previousLevel(index) {
    switch (index) {
      case 2: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel1.nativeElement.childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
      case 3: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel2.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
      case 4: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel3.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
      case 5: {
        let nextLevelFirstNode = new ElementRef(this.elemLevel4.nativeElement.childNodes[0].childNodes[0].childNodes[1].childNodes[0]);
        nextLevelFirstNode.nativeElement.focus();
        break;
      }
    }
  }

  tabOnClose(event) {
    console.log(event);
  }

  navPathFound: boolean = false;
  navPathUrl: string = "";
  BreadcrumbData: any[] = [];
  getBreadcrumbWithNavPath(breadcerumbUrl) {
    this.navPathFound = false;
    this.navPathUrl = "";
    this.BreadcrumbData = [];
    for (let i = this.tempData.length - 1; i >= 0; i--) {
      if (this.tempData[i].itemData != null) {
        for (let j = 0; j < this.tempData[i].itemData.length; j++) {
          if (this.tempData[i].itemData[j]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
            this.navPathFound = true;
            this.navPathUrl = this.tempData[i].itemData[j]?.itemLink;
            if (this.tempData[i].itemData[j].itemData != null) {
              this.menuItemData(this.tempData[i].itemData[j].itemData);
            }
          } else {
            if (this.tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < this.tempData[i].itemData[j].itemData.length; k++) {
                if (this.tempData[i].itemData[j].itemData[k]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
                  this.navPathFound = true;
                  this.navPathUrl = this.tempData[i].itemData[j].itemData[k]?.itemLink;
                  if (this.tempData[i].itemData[j].itemData[k].itemData != null) {
                    this.menuItemData(this.tempData[i].itemData[j].itemData[k].itemData);
                  }
                } else {
                  if (this.tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < this.tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (this.tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
                        this.navPathFound = true;
                        this.navPathUrl = this.tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          this.menuItemData(this.tempData[i].itemData[j].itemData[k].itemData[l].itemData);
                        }
                      }
                      else {
                        if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < this.tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
                              this.navPathFound = true;
                              this.navPathUrl = this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m].itemData != null) {
                                this.menuItemData(this.tempData[i].itemData[j].itemData[k].itemData[l].itemData);
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return [];
  }

  getBreadcrumbObjWithNavPath(breadcerumbUrl) {
    for (let i = 8; i >= 0; i--) {
      if (this.tempData[i].itemData != null) {
        for (let j = 0; j < this.tempData[i].itemData.length; j++) {
          if (this.tempData[i].itemData[j]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
            return this.tempData[i].itemData[j];
          } else {
            if (this.tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < this.tempData[i].itemData[j].itemData.length; k++) {
                if (this.tempData[i].itemData[j].itemData[k]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
                  return this.tempData[i].itemData[j].itemData[k];
                } else {
                  if (this.tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < this.tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (this.tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
                        return this.tempData[i].itemData[j].itemData[k].itemData[l];
                      }
                      else {
                        if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < this.tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
                              return this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m];
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return [];
  }

  getBreadcrumbForTopic(breadcerumbUrl) {
    this.BreadcrumbData = [];
    for (let i = 8; i >= 0; i--) {
      if (this.tempData[i].itemData != null) {
        for (let j = 0; j < this.tempData[i].itemData.length; j++) {
          if (this.tempData[i].itemData[j]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
            this.BreadcrumbData.push(this.tempData[i].itemData[j]?.navPath);
          }
          if (this.tempData[i].itemData[j]?.navPath == "") {
            if (this.tempData[i].itemData[j]?.itemData != null) {
              for (let k = 0; k < this.tempData[i].itemData[j].itemData.length; k++) {
                if (this.tempData[i].itemData[j]?.itemData[k]?.navPath?.toLowerCase().startsWith(breadcerumbUrl.toLowerCase())) {
                  this.BreadcrumbData.push(this.tempData[i].itemData[j]?.itemData[k]?.navPath);
                }
              }
            }
          }
        }
      }
    }
    return this.BreadcrumbData;
  }

  area: string = "";
  getBreadcrumbWithRouteUrl(breadcerumbUrl) {
    this.area = "";
    for (let i = this.tempData.length - 1; i >= 0; i--) {
      if (this.tempData != null && this.tempData[i].itemData != null) {
        for (let j = 0; j < this.tempData[i].itemData.length; j++) {
          if (this.tempData[i].itemData[j].itemData != null) {
            for (let k = 0; k < this.tempData[i].itemData[j].itemData.length; k++) {
              if (this.tempData[i].itemData[j].itemData[k]?.itemLink?.includes(breadcerumbUrl)) {
                this.area = this.tempData[i].item;
                return;
              }
              else {
                if (this.tempData[i].itemData[j].itemData[k].itemData != null) {
                  for (let l = 0; l < this.tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                    if (this.tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink?.includes(breadcerumbUrl)) {
                      this.area = this.tempData[i].item;
                      return;
                    }
                    else {
                      if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                        for (let m = 0; m < this.tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                          if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink?.includes(breadcerumbUrl)) {
                            this.area = this.tempData[i].item;
                            return;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return [];
  }

  getBreadcrumbForNav(breadcerumbUrl) {
    this.area = "";
    for (let i = 8; i >= 0; i--) {
      if (this.tempData != null && this.tempData[i].itemData != null) {
        for (let j = 0; j < this.tempData[i].itemData.length; j++) {
          if (this.tempData[i].itemData[j]?.navPath?.toLowerCase()?.startsWith(breadcerumbUrl.toLowerCase())) {
            this.area = this.tempData[i].item;
            return;
          } else {
            if (this.tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < this.tempData[i].itemData[j].itemData.length; k++) {
                if (this.tempData[i].itemData[j].itemData[k]?.navPath?.toLowerCase()?.startsWith(breadcerumbUrl.toLowerCase())) {
                  this.area = this.tempData[i].item;
                  return;
                } else {
                  if (this.tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < this.tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (this.tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.toLowerCase()?.startsWith(breadcerumbUrl.toLowerCase())) {
                        this.area = this.tempData[i].item;
                        return;
                      }
                      else {
                        if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < this.tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (this.tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.toLowerCase()?.startsWith(breadcerumbUrl.toLowerCase())) {
                              this.area = this.tempData[i].item;
                              return;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return [];
  }

  menuItemData(itemData) {
    this.BreadcrumbData = [];
    for (let i = 0; i < itemData.length; i++) {
      this.BreadcrumbData.push(itemData[i].navPath);
    }
    return this.BreadcrumbData;
  }
}
